export const getCreateCollectionUrl = payload => {
  return {
    url: "/api/v1/collections",
    config: payload,
  };
};

export const getEditCollectionUrl = (collectionId, collectionData) => {
  return { url: `/api/v1/collections/${collectionId}`, config: collectionData };
};

export const getLoadCollectionUrl = (collectionId, { limit, pagingToken }) => {
  const params = {};
  if (limit) {
    params.limit = limit;
  }
  if (pagingToken) {
    params.paging_token = pagingToken;
  }
  return { url: `/api/v1/collections/${collectionId}`, config: { params } };
};

export const getDeleteCollectionUrl = collectionId => {
  return { url: `/api/v1/collections/${collectionId}` };
};

export const getAddPostToCollectionUrl = ({ postId, collectionId }) => {
  return { url: `/api/v1/collections/${collectionId}/posts`, config: { postId } };
};



// WEBPACK FOOTER //
// ./src/api/CollectionApi.js